<template>
  <div id="page-wrap">
    <hero-section></hero-section>
    <slot></slot>
  </div>
</template>
<script>
import HeroSection from '@/components/hero/HeroSection.vue';

export default {
  name: 'PageLayout',
  components: {
    HeroSection,
  },
};
</script>
